import DanhMucCuocThanhTraTrungPage from './DanhMucCuocThanhTraTrungPage.jsx'
import DanhMucTongHopThanhTraPage from './DanhMucTongHopThanhTraPage.jsx'

export {
  DanhMucCuocThanhTraTrungPage,
  DanhMucTongHopThanhTraPage
}


// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra-trung/index.js